(function () {
  'use strict';

  class CSTCompleteTheLook {

    constructor(root) {

      this.root = root;

      this.openButton =
        root.querySelector('[data-cst-open]');

      this.closeButton =
        root.querySelector('[data-cst-close]');

      this.overlay =
        root.querySelector('[data-cst-overlay]');

      this.drawer =
        root.querySelector('[data-cst-drawer]');

      this.products =
        Array.from(
          root.querySelectorAll('[data-cst-product]')
        );

      this.addSelectedButton =
        root.querySelector('[data-cst-add-selected]');

      this.buttonText =
        root.querySelector('[data-cst-button-text]');

      this.mainVariantId =
        root.dataset.mainVariantId;

      this.isAdding = false;

      this.init();
    }


    /* =========================================================
       INIT
    ========================================================= */

    init() {

      if (this.openButton) {

        this.openButton.addEventListener(
          'click',
          () => this.open()
        );

      }


      if (this.closeButton) {

        this.closeButton.addEventListener(
          'click',
          () => this.close()
        );

      }


      if (this.overlay) {

        this.overlay.addEventListener(
          'click',
          () => this.close()
        );

      }


      this.products.forEach((product) => {

        this.initializeProduct(product);

      });


      if (this.addSelectedButton) {

        this.addSelectedButton.addEventListener(
          'click',
          () => this.addItemsToCart()
        );

      }


      document.addEventListener('keydown', (event) => {

        if (
          event.key === 'Escape' &&
          this.drawer &&
          this.drawer.classList.contains('is-active')
        ) {

          this.close();

        }

      });


      this.updateButton();

    }


    /* =========================================================
       INITIALIZE PRODUCT
    ========================================================= */

    initializeProduct(product) {

      const checkbox =
        product.querySelector('[data-cst-checkbox]');

      const selects =
        Array.from(
          product.querySelectorAll('[data-cst-option-select]')
        );

      /*
       * Parse variants from Liquid JSON.
       */

      const variantsScript =
        product.querySelector('[data-cst-variants]');

      let variants = [];

      if (variantsScript) {

        try {

          variants =
            JSON.parse(
              variantsScript.textContent
            );

        } catch (error) {

          console.error(
            'Complete The Look variant data error:',
            error
          );

        }

      }


      /*
       * Store variants on the element.
       */

      product.cstVariants = variants;


      /*
       * Update variant based on default selections.
       */

      this.updateSelectedVariant(product);


      /*
       * Product click toggles checkbox.
       */

      product.addEventListener('click', (event) => {

        /*
         * Do not toggle checkbox when interacting
         * with selects, labels or option controls.
         */

        if (
          event.target.closest(
            '.cst-ctl__variant-options'
          )
        ) {

          return;

        }


        if (event.target === checkbox) {

          this.updateProductState(product);

          return;

        }


        if (!checkbox) {

          return;

        }


        checkbox.checked =
          !checkbox.checked;

        this.updateProductState(product);

      });


      /*
       * Variant option changes.
       */

      selects.forEach((select) => {

        select.addEventListener(
          'change',
          () => {

            this.updateSelectedVariant(product);

          }
        );

      });

    }


    /* =========================================================
       GET SELECTED OPTION VALUES
    ========================================================= */

    getSelectedOptionValues(product) {

      const selects =
        Array.from(
          product.querySelectorAll(
            '[data-cst-option-select]'
          )
        );

      return selects.map((select) => select.value);

    }


    /* =========================================================
       UPDATE SELECTED VARIANT
    ========================================================= */

    updateSelectedVariant(product) {

      const variants =
        product.cstVariants || [];

      /*
       * Product with only one variant.
       */

      if (!variants.length) {

        return;

      }


      const selectedOptions =
        this.getSelectedOptionValues(product);


      /*
       * Find the exact variant matching all
       * currently selected option values.
       */

      let selectedVariant =
        variants.find((variant) => {

          if (!variant.options) {

            return false;

          }

          return variant.options.every(
            (optionValue, index) => {

              return optionValue ===
                selectedOptions[index];

            }

          );

        });


      /*
       * Fallback to first available variant.
       */

      if (!selectedVariant) {

        selectedVariant =
          variants.find(
            (variant) => variant.available
          );

      }


      if (!selectedVariant) {

        selectedVariant =
          variants[0];

      }


      if (!selectedVariant) {

        return;

      }


      /*
       * Save selected variant ID.
       */

      product.dataset.variantId =
        selectedVariant.id;


      /*
       * Update product availability UI.
       */

      const status =
        product.querySelector(
          '[data-cst-variant-status]'
        );


      if (status) {

        if (selectedVariant.available) {

          status.textContent = '';

          status.classList.remove(
            'is-unavailable'
          );

        } else {

          status.textContent =
            'This option is currently unavailable';

          status.classList.add(
            'is-unavailable'
          );

        }

      }


      /*
       * Update image if variant has a featured image.
       */

      this.updateVariantImage(
        product,
        selectedVariant
      );

    }


    /* =========================================================
       UPDATE VARIANT IMAGE
    ========================================================= */

    updateVariantImage(product, variant) {

      if (
        !variant ||
        !variant.featured_image
      ) {

        return;

      }


      const image =
        product.querySelector(
          '.cst-ctl__product-image'
        );


      if (!image) {

        return;

      }


      const variantImage =
        variant.featured_image;


      if (variantImage.src) {

        image.src = variantImage.src;

      }

    }


    /* =========================================================
       CHECKBOX STATE
    ========================================================= */

    updateProductState(product) {

      const checkbox =
        product.querySelector('[data-cst-checkbox]');

      if (!checkbox) {

        return;

      }


      product.classList.toggle(
        'is-selected',
        checkbox.checked
      );


      this.updateButton();

    }


    /* =========================================================
       GET SELECTED PRODUCTS
    ========================================================= */

    getSelectedProducts() {

      return this.products.filter(
        (product) => {

          const checkbox =
            product.querySelector(
              '[data-cst-checkbox]'
            );

          return (
            checkbox &&
            checkbox.checked
          );

        }

      );

    }


    /* =========================================================
       BUTTON TEXT
    ========================================================= */

    updateButton() {

      const selected =
        this.getSelectedProducts();

      const count =
        selected.length;


      if (!this.buttonText) {

        return;

      }


      if (count === 0) {

        this.buttonText.textContent =
          'SELECT ITEMS';

      } else {

        this.buttonText.textContent =
          'SELECTED ITEMS (' +
          count +
          ')';

      }

    }


    /* =========================================================
       OPEN DRAWER
    ========================================================= */

    open() {

      if (!this.drawer) {

        return;

      }


      this.drawer.classList.add(
        'is-active'
      );

      this.overlay.classList.add(
        'is-active'
      );


      this.drawer.setAttribute(
        'aria-hidden',
        'false'
      );


      document.body.classList.add(
        'cst-ctl--drawer-open'
      );

    }


    /* =========================================================
       CLOSE DRAWER
    ========================================================= */

    close() {

      if (!this.drawer) {

        return;

      }


      this.drawer.classList.remove(
        'is-active'
      );

      this.overlay.classList.remove(
        'is-active'
      );


      this.drawer.setAttribute(
        'aria-hidden',
        'true'
      );


      document.body.classList.remove(
        'cst-ctl--drawer-open'
      );

    }


    /* =========================================================
       ADD ITEMS TO CART
    ========================================================= */

    async addItemsToCart() {

      if (this.isAdding) {

        return;

      }


      const selected =
        this.getSelectedProducts();


      const items = [];


      /*
       * MAIN PRODUCT
       */

      if (this.mainVariantId) {

        items.push({
          id: Number(this.mainVariantId),
          quantity: 1
        });

      }


      /*
       * SELECTED ADD-ON PRODUCTS
       *
       * Uses the variant currently selected
       * by the customer.
       */

      selected.forEach((product) => {

        const variantId =
          product.dataset.variantId;


        if (!variantId) {

          return;

        }


        const variants =
          product.cstVariants || [];


        const selectedVariant =
          variants.find(
            (variant) =>
              String(variant.id) ===
              String(variantId)
          );


        /*
         * Prevent unavailable variants.
         */

        if (
          selectedVariant &&
          !selectedVariant.available
        ) {

          return;

        }


        items.push({
          id: Number(variantId),
          quantity: 1
        });

      });


      if (!items.length) {

        return;

      }


      this.setLoading(true);


      try {

        const response =
          await fetch(
            window.Shopify.routes.root +
            'cart/add.js',
            {

              method: 'POST',

              credentials:
                'same-origin',

              headers: {
                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json',

                'X-Requested-With':
                  'XMLHttpRequest'
              },

              body:
                JSON.stringify({
                  items: items
                })

            }

          );


        if (!response.ok) {

          const errorData =
            await response
              .json()
              .catch(() => null);


          throw new Error(
            errorData?.description ||
            'Unable to add products to cart.'
          );

        }


        const data =
          await response.json();


        /*
         * Theme events.
         */

        document.dispatchEvent(

          new CustomEvent(
            'product:added',
            {
              detail: {
                product: data
              }
            }
          )

        );


        document.dispatchEvent(

          new CustomEvent(
            'cst:complete-look:added',
            {
              detail: {
                items:
                  data.items || items,

                cart: data
              }
            }
          )

        );


        await this.refreshCart();


        this.close();


        this.showSuccess();


      } catch (error) {

        console.error(
          'Complete The Look:',
          error
        );


        this.showError(
          error.message
        );

      } finally {

        this.setLoading(false);

      }

    }


    /* =========================================================
       REFRESH CART
    ========================================================= */

    async refreshCart() {

      try {

        const response =
          await fetch(
            window.Shopify.routes.root +
            'cart.js',
            {

              method: 'GET',

              credentials:
                'same-origin',

              headers: {
                'Accept':
                  'application/json'
              }

            }

          );


        if (!response.ok) {

          return;

        }


        const cart =
          await response.json();


        document.dispatchEvent(

          new CustomEvent(
            'cst:cart:updated',
            {
              detail: {
                cart: cart
              }
            }
          )

        );


        const count =
          cart.item_count;


        document
          .querySelectorAll(
            '[data-cart-count], .Header__CartCount, .CartCount'
          )
          .forEach((element) => {

            element.textContent =
              count;

          });


      } catch (error) {

        console.warn(
          'Complete The Look cart refresh:',
          error
        );

      }

    }


    /* =========================================================
       LOADING STATE
    ========================================================= */

    setLoading(isLoading) {

      this.isAdding =
        isLoading;


      if (!this.addSelectedButton) {

        return;

      }


      this.addSelectedButton.disabled =
        isLoading;


      this.addSelectedButton.classList.toggle(
        'is-loading',
        isLoading
      );


      if (isLoading) {

        this.buttonText.textContent =
          'ADDING...';

      } else {

        this.updateButton();

      }

    }


    /* =========================================================
       SUCCESS
    ========================================================= */

    showSuccess() {

      document.dispatchEvent(

        new CustomEvent(
          'cst:complete-look:success'
        )

      );

    }


    /* =========================================================
       ERROR
    ========================================================= */

    showError(message) {

      alert(
        message ||
        'Unable to add products to cart.'
      );

    }

  }


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initCompleteTheLook() {

    document
      .querySelectorAll(
        '[data-cst-complete-look]'
      )
      .forEach((root) => {

        if (
          root.dataset.cstInitialized ===
          'true'
        ) {

          return;

        }


        root.dataset.cstInitialized =
          'true';


        new CSTCompleteTheLook(
          root
        );

      });

  }


  /*
   * Normal page load
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initCompleteTheLook
    );

  } else {

    initCompleteTheLook();

  }


  /*
   * Shopify Theme Editor
   */

  document.addEventListener(
    'shopify:section:load',
    initCompleteTheLook
  );


})();
